import { takeLatest, put, call } from 'redux-saga/effects';
import { userGet, updatePassword } from '../../network/user';
import {
  USER_SHOW,
  USER_FETCH,
  IS_LOADED
} from './types';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';
import { USER_LOGOUT } from '../token/types';
import { UPDATE_PASSWORD, UPDATE_PASSWORD_SUCESS } from './types';

function* showUser(action) {
  const { payload } = action;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(userGet, payload);
    yield put({ type: USER_FETCH, payload: data.payload });
    yield put({ type: IS_LOADED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: USER_LOGOUT });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
};

function* updatePass(action) {
  const { payload } = action;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(updatePassword, payload);
    yield put({ type: UPDATE_PASSWORD_SUCESS, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: UPDATE_PASSWORD_SUCESS, payload: STATUS.ERROR });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
};

function* watchFetchUser() {
  yield takeLatest(USER_SHOW, showUser);
}

function* watchUpdatePassword() {
  yield takeLatest(UPDATE_PASSWORD, updatePass);
}

export default [
  watchFetchUser(),
  watchUpdatePassword()
];